module.exports = __webpack_public_path__ + "static/media/8.39bbe28e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格选中态/8.png
// module id = 1280
// module chunks = 0